
import { ProductionStats, Statistics, StatisticsQuery } from "BrokerTsLib/src/dtos"
import { useMutation } from "react-query"
import axios from "axios"
import { useApp } from "./useApp"
import { Product } from "BrokerTsLib/src/enums"

export const baseUrl = process.env.PUBLIC_URL
const apiVehicleUrl = process.env.REACT_APP_STATISTICS_VEHICLE_API
const apiTravelUrl = process.env.REACT_APP_STATISTICS_TRAVEL_API
const apiPropertyUrl = process.env.REACT_APP_STATISTICS_PROPERTY_API


export const useUrl = () => {
    const { product } = useApp()

    let url: string | undefined = ''

    switch (product) {
        case Product.TravelInsurance: url = apiTravelUrl; break;
        case Product.PropertyInsurance: url = apiPropertyUrl; break;
        default: url = apiVehicleUrl; break;
    }

    return `${baseUrl}/${url}`
}

export const useGetStatistics = () => {
    const url = useUrl()

    return useMutation((search: StatisticsQuery) =>
        axios.post<Statistics>(`${url}/GetStatistics`, search))
}

export const useGetProductionStatistics = () => {
    const url = useUrl()

    return useMutation((search: StatisticsQuery) =>
        axios.post<ProductionStats>(`${url}/GetProductionStatistics`, search))
}